import { render, staticRenderFns } from "./TPA.vue?vue&type=template&id=b858bfb2&"
import script from "./TPA.vue?vue&type=script&lang=js&"
export * from "./TPA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports